import React, { useState } from "react";
import RoomCard from "../RoomCard";
import "./styles.css";

const XrScienceMenu = ({ onRequestNewRoom, availableRooms }) => {
  return (
    <>
      <p className="create-menu-text">
        Science XR presents static content for education, outreach and discussions in science.
      </p>
      <div className="cards-container">
        {availableRooms &&
          availableRooms.map((room) => (
            <RoomCard
              key={room.id}
              name={room.name}
              imgUrl={room.thumbnail}
              description={room.description}
              handleClick={() => onRequestNewRoom({ id: room.id })}
            />
          ))}
      </div>
    </>
  );
};
export default XrScienceMenu;
